export interface CompositeFilter {
  compositeFilter: { filter1: Filter; filter2: Filter; operation: string };
}

export type FilterValue = boolean | number | string;

export interface ValueFilter {
  valueFilter: {
    columnName: string;
    filterType: string;
    value: FilterValue | FilterValue[] | { value: FilterValue | FilterValue[] };
  };
}

export interface SimpleFilter {
  simpleFilter: { columnName: string; filterType: string };
}

export type Filter = CompositeFilter | ValueFilter | SimpleFilter;

export interface TableData {
  headers: { name: string; type: string }[];
  rows: any[][];
  cursorKey?: string;
}

export const GraphQL = {
  FilterTypes: {
    GreaterThan: 'GREATER_THAN',
    GreaterThanOrEqual: 'GREATER_THAN_OR_EQUAL',
    IsNotNull: 'IS_NOT_NULL',
    IsNull: 'IS_NULL',
    LessThan: 'LESS_THAN',
    LessThanOrEqual: 'LESS_THAN_OR_EQUAL',
    In: 'IN',
    NotIn: 'NOT_IN',
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    BeginsWith: 'BEGINS_WITH',
    EndsWith: 'ENDS_WITH',
  },
  Operations: {
    And: 'AND',
    Or: 'OR',
  },
};
